// Elements 
import Footer from './footer';
import Header from './header';
import React, {useRef} from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';

// Images
import Image01 from '../assets/whyus_02.webp'
// css
import "../contact.css"

function Contact() {

     const ConctactForm = useRef();
      
      
        const SendEmail = (e) => {
          e.preventDefault();
       
          const {name, email, message, mobile } = ConctactForm.current.elements;
      
          emailjs.sendForm('service_a8sq73e', 'template_7000lft', ConctactForm.current,  'tJeEVtt8l6_rEiFHT')
            .then((result) => {
                toast.success("Hi Your Message Successfully! Our team will contact you soon.");
                console.log(result.text)
            }, (error) => {
           
                toast.error("Some technical error occurred. Please try again after sometime / contact@saintes.in ");
                console.log(error)
            });
        };

    return (
        <section className='paint-container contact-container' id="smooth-wrapper">
      <Header />
      <div class="form-section-mind-dark">
          <ToastContainer />
          <div class="container-2">
              <div class="w-layout-grid form-grid-mind-dark">
                  <div><img src={Image01} alt={Image01} class="form-image-dark" />
                  </div>
                  <div class="column is--contact">
                      <div class="form-wrapper-2">
                          <div class="title-wrap">
                              <h2 class="section-heading is--form">Get in Touch</h2>
                              <p class="p-text top-margin text-align-left">Ready to brew something
                                  extraordinary?<br />Let’s collaborate!</p>
                              <p className='text-white fs-5 pt-md-2'>
                                  <span className='col-lg-11 d-sm-inline-flex'>114/1,22nd cross,<br /> 30th main, B.S.K.
                                      2nd stage, <br />Opp. KIMS college, <br />Bangalore-560070 </span>

                              </p>
                              <p className='text-white fs-5 pt-md-2'>
                                  <span className='col-lg-11 d-sm-inline-flex'> +91-998 658 9309 / +91 990 185 5334
                                  </span>
                              </p>
                              <p className='text-white fs-5 pt-md-2'>

                                  <span className='col-lg-11 d-sm-inline-flex'> pints.kv@gmail.com / pints.jj@gmail.com
                                  </span>
                              </p>
                          </div>
                          <div class="wrapper-1160px contact-flex">
                              <div class="contact-text-container"></div>
                              <div class="contact-form-block-container">
                                  <div class="contact-block">
                                      <div class="form-block-contact w-form">
                                          <form id="wf-form-Contact" ref={ConctactForm} onSubmit={SendEmail}
                                              class="form-contact">
                                              <input class="text-field-2 w-input" maxlength="256" name="name"
                                                  placeholder="Enter Your Name" type="text" id="name" required />
                                              <input class="text-field-2 w-input" maxlength="256" name="email"
                                                  placeholder="Email" type="email" id="email" required />
                                              <input class="text-field-2 w-input" maxlength="256" name="mobile"
                                                  placeholder="Phone Number" type="number" id="mobile" />
                                              <textarea placeholder="Message" maxlength="5000" id="message"
                                                  name="message" class="textarea w-input"></textarea>
                                              <input type="submit" class="link-block is--form w-button" value="Send" />
                                          </form>
                                          <div class="success-message w-form-done" tabindex="-1" role="region"
                                              aria-label="Contact success">
                                              <div class="text-success">Thank you! Your submission has been received!
                                              </div>
                                          </div>
                                          <div class="error-message w-form-fail" tabindex="-1" role="region"
                                              aria-label="Contact failure">
                                              <div class="text-error">Oops! Something went wrong while submitting the
                                                  form.
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <Footer />
  </section>
    )}

export default Contact;    